import { Link } from "react-router-dom";
import PageBanner from "../../PageBanner";
import SocialMediaSidebar from "../../SocialMediaSidebar";
import SectionHeader from "../../SectionHeader";
import ScrollToTopButton from "../../ScrollToTopButton";
import SectionHeaderNoPDF from "../../SectionHeaderNoPDF";

const OfferingDataDrivenInsights = () => {
  return (
    <>
      <div>
        <SocialMediaSidebar />
      </div>
      <PageBanner
        title="Data-Driven Insights"
        breadcrumb={[
          { label: "Home", href: "/" },
          { label: "Offerings" },
        ]}
      />
      <div className="max-w-6xl mx-auto p-4">
        <SectionHeaderNoPDF
          title="Data-Driven Insights @ AJEEVI"
          shareUrl="https://swmecom.ajeevi.in/data-insights"
        />
      </div>
      <div>
        <ScrollToTopButton />
      </div>

      {/* Page content */}
      <div className="w-full px-4 sm:px-6 md:px-10 lg:px-28 py-10 bg-white text-gray-800 text-justify">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          {/* Summary Section */}
          <div className="mb-10">
            <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
              Summary
            </h4>
            <p className="text-black mb-4 text-lg">
              Data-Driven Insights transform raw waste management operations into actionable intelligence through advanced analytics and visualization tools. This powerful capability enables municipalities and waste management companies to optimize every aspect of their operations based on empirical evidence.
            </p>
            <p className="text-black text-lg">
              By leveraging IoT sensors, GPS tracking, and AI-powered analytics, organizations can achieve unprecedented visibility into waste collection patterns, resource utilization, and service quality, leading to continuous operational improvements and cost savings.
            </p>
          </div>

          {/* Introduction Section */}
          <div className="mb-10">
            <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
              Introduction
            </h4>
            <p className="text-black mb-4 text-lg">
              In the era of smart cities, waste management decisions should be guided by data rather than intuition. AJEEVI's Data-Driven Insights platform aggregates information from all connected systems - collection vehicles, smart bins, customer interfaces, and workforce management - to provide a comprehensive operational picture.
            </p>
            <p className="text-black text-lg">
              Our analytics solutions convert complex datasets into clear visualizations and actionable recommendations, empowering managers to identify inefficiencies, predict future needs, and demonstrate performance improvements to stakeholders.
            </p>
          </div>

          {/* Key Features Section */}
          <div className="mb-10">
            <h5 className="text-xl font-semibold mb-4 text-black">
              Key Features of Data-Driven Insights Platform:
            </h5>
            <ul className="list-disc pl-6 space-y-2 text-lg text-black">
              <li>
                <strong>Real-Time Monitoring Dashboards:</strong> Live views of fleet movements, bin fill levels, and workforce productivity
              </li>
              <li>
                <strong>Predictive Analytics:</strong> AI models forecasting waste generation patterns and collection demands
              </li>
              <li>
                <strong>Performance Benchmarking:</strong> Comparative analysis across zones, routes, and time periods
              </li>
              <li>
                <strong>Anomaly Detection:</strong> Automated identification of operational deviations and service disruptions
              </li>
              <li>
                <strong>Custom Reporting:</strong> Tailored reports for different stakeholders (operators, managers, city officials)
              </li>
              <li>
                <strong>API Integrations:</strong> Seamless connectivity with existing municipal systems and databases
              </li>
            </ul>
          </div>

          {/* Benefits Section */}
          <div className="mb-10">
            <h5 className="text-xl font-semibold mb-3 text-black">
              Operational Benefits
            </h5>
            <p className="text-black text-lg mb-4">
              Implementing Data-Driven Insights delivers measurable improvements across waste management operations:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
              <li>15-30% improvement in collection route efficiency</li>
              <li>20-40% reduction in operational costs through optimized resource allocation</li>
              <li>Enhanced decision-making with empirical evidence rather than estimates</li>
              <li>Proactive identification of service issues before they escalate</li>
              <li>Data-backed justification for budget requests and policy changes</li>
              <li>Transparent performance tracking for accountability and continuous improvement</li>
            </ul>
          </div>

          {/* Implementation Section */}
          <div className="mb-10">
            <h5 className="text-xl font-semibold mb-3 text-black">
              Implementation Considerations
            </h5>
            <p className="text-black text-lg mb-4">
              Successful deployment of analytics solutions requires:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
              <li>Comprehensive data collection infrastructure (sensors, GPS, etc.)</li>
              <li>Clear definition of key performance indicators and success metrics</li>
              <li>Staff training on data interpretation and decision-making processes</li>
              <li>Gradual rollout starting with pilot areas before city-wide implementation</li>
              <li>Regular review cycles to refine analytics models and dashboards</li>
              <li>Data governance policies for quality control and privacy protection</li>
            </ul>
          </div>

          {/* Ajeevi's Contribution Section */}
          <div>
            <h5 className="text-xl font-semibold mb-3 text-black">
              Ajeevi's Data Analytics Solutions
            </h5>
            <p className="text-black mb-4 text-lg">
              AJEEVI offers specialized analytics solutions for waste management:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
              <li>
                <strong>Operational Intelligence Suite:</strong> Comprehensive dashboards tracking all waste management metrics
              </li>
              <li>
                <strong>Waste Flow Analysis:</strong> Visualization of waste streams from generation to final disposal
              </li>
              <li>
                <strong>Route Optimization Engine:</strong> AI-powered recommendations for collection efficiency
              </li>
              <li>
                <strong>Citizen Engagement Analytics:</strong> Insights into public participation and satisfaction
              </li>
              <li>
                <strong>Sustainability Reporting:</strong> Automated generation of environmental impact metrics
              </li>
            </ul>
            <p className="text-black text-lg">
              Discover how AJEEVI's Data-Driven Insights can transform your waste management operations. Visit{" "}
              <a
                href="http://www.ajeevi.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#00D084] hover:underline"
              >
                www.ajeevi.com
              </a>{" "}
              for more information.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default OfferingDataDrivenInsights;